const mapping: Record<string, string> = {
  id: 'q=>q.Id',
}

export const mapSortPrintQRCodeItemsParam = (key: string) => mapping[key]
